import { render, staticRenderFns } from "./DetailProductRadiant.vue?vue&type=template&id=4cbf3ce0&"
import script from "./DetailProductRadiant.vue?vue&type=script&lang=js&"
export * from "./DetailProductRadiant.vue?vue&type=script&lang=js&"
import style0 from "./DetailProductRadiant.vue?vue&type=style&index=0&id=4cbf3ce0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports